import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";

// Swiper Styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/autoplay";

import "../styles/Client.css";
import maintenanceImage from "../assets/client1A.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
import Beams from "./Beams";
import Header from "./Header";
import Footer from "./Footer";

// Logos
import logo1 from "../assets/client1.png";
import logo2 from "../assets/client2.png";
import logo3 from "../assets/client3.jpg";
import logo4 from "../assets/client4.png";
import logo5 from "../assets/client5.png";
import logo6 from "../assets/client6.jpg";
import logo7 from "../assets/client7.png";
import logo8 from "../assets/client8.png";
import logo9 from "../assets/client9.webp";
import logo10 from "../assets/client19.webp";
import logo11 from "../assets/client2.png";
import logo12 from "../assets/client12.png";
import logo13 from "../assets/client13.png";
import logo14 from "../assets/client14.png";
import logo15 from "../assets/client15.png";
import logo16 from "../assets/client16.jpg";
import logo17 from "../assets/client17.jpg";
import logo18 from "../assets/client18.png";

// Completion Certificates Imports (22 PNG Images)
import cert1 from "../assets/cert1.png";
// import cert2 from "../assets/cert2.png";
import cert3 from "../assets/cert3.png";
import cert4 from "../assets/cert4.png";
import cert5 from "../assets/cert5.png";
import cert6 from "../assets/cert6.png";
import cert7 from "../assets/cert7.png";
import cert8 from "../assets/cert8.png";
import cert9 from "../assets/cert9.png";
import cert10 from "../assets/cert10.png";
import cert11 from "../assets/cert11.png";
import cert12 from "../assets/cert12.png";
import cert13 from "../assets/cert13.png";
import cert14 from "../assets/cert14.png";
import cert15 from "../assets/cert15.png";
import cert16 from "../assets/cert16.png";
import cert17 from "../assets/cert17.png";
import cert18 from "../assets/cert18.png";
import cert19 from "../assets/cert19.png";
import cert20 from "../assets/cert20.png";
import cert21 from "../assets/cert21.png";
import cert22 from "../assets/cert22.png";

const Client = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    window.scrollTo(0, 0);
  }, []);

  const advancedLogos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8, logo9, logo10];

  const certificates = [
    cert1, cert3, cert4, cert5, cert6, cert7, cert8, cert9, cert10,
    cert11, cert12, cert13, cert14, cert15, cert16, cert17, cert18, cert19, cert20,
    cert21, cert22
  ];

  return (
    <>
      <Header />

      <div className="client-services-container">
        <div className="client-beam-background">
          <Beams
            beamWidth={1.4}
            beamHeight={30}
            beamNumber={14}
            lightColor="#00CCFF"
            speed={20}
            noiseIntensity={0}
            scale={0.19}
            rotation={59}
          />
        </div>

        <div className="client-services-left" data-aos="fade-right">
          <h1>The Key Investment For Success</h1>
          <p>
            We are proud to serve a diverse and esteemed clientele across industries such as renewable energy, oil & gas, infrastructure, and industrial facilities. Our clients range from multinational corporations to government agencies and private enterprises. Each partnership is built on trust, quality, and consistent performance. By understanding unique project needs and delivering tailored solutions, we’ve become a trusted name in the field. Collaborate with us and experience the reliability, innovation, and excellence that our clients rely on every day.
          </p>
        </div>

        <div className="client-services-right" data-aos="fade-left">
          <img
            src={maintenanceImage}
            alt="Client Collaboration Visual"
            className="client-gif"
          />
        </div>
      </div>

      <div className="client-bottom-section">
        <div className="client-bottom-text" data-aos="fade-up">
          <h2>Our Clients</h2>
          <h4>Catering To Clients From Energy Industries</h4>
          <p>
            One of our core values is client success. We have earned our reputation through our work.
          </p>
          <ul>
            <li> Infrastructure</li>
            <li> Oil & Gas</li>
            <li> Renewable Energy</li>
            <li> Industrial Facilities</li>
          </ul>
          <p>
            Partner with us for your next project, and experience the difference of working with industry leaders committed to your success.
          </p>
        </div>

        {/* --- ADVANCED DRAGGABLE SLIDER END --- */}

        {/* --- COMPLETION CERTIFICATE SLIDER (SMOOTH AUTO LOOP) START --- */}
     <div className="certificate-slider-container" data-aos="fade-up">
  <h2 className="slider-title">Completion Certificates</h2>
  <Swiper
    modules={[Autoplay, FreeMode]}
    slidesPerView={4.2}      // Mobile: 1 full, bit of next
    spaceBetween={30}
    loop={true}              // Seamless infinite loop
    freeMode={true}          // Smooth dragging
    grabCursor={true}
    speed={10000}             // Constant speed (ticker style)
    autoplay={{
      delay: 0,              // No pauses
      disableOnInteraction: false,
    }}
    breakpoints={{
      768: {
        slidesPerView: 2.2,  // Tablet: Larger certificates
      },
      1024: {
        slidesPerView: 2.8,  // Desktop: Big enough to read text clearly
      },
    }}
    className="certificate-swiper"
  >
    {certificates.map((cert, index) => (
      <SwiperSlide key={index}>
        <div className="certificate-card-advanced">
          <div className="cert-image-wrapper">
            <img src={cert} alt={`Certificate ${index + 1}`} />
          </div>
        </div>
      </SwiperSlide>
    ))}
  </Swiper>
</div>



        {/* --- COMPLETION CERTIFICATE SLIDER END --- */}

        {/* Standard Infinite Logo Slider (Existing) */}
        <div className="client-logo-slider">
          <div className="client-logo-track">
            {[...Array(2)].map((_, i) => (
              <React.Fragment key={i}>
                <img src={logo1} alt="Client 1" />
                <img src={logo2} alt="Client 2" />
                <img src={logo3} alt="Client 3" />
                <img src={logo4} alt="Client 4" />
                <img className="pt1" src={logo5} alt="Client 5" />
                <img src={logo6} alt="Client 6" />
                <img src={logo7} alt="Client 7" />
                <img src={logo8} alt="Client 8" />
                <img src={logo9} alt="Client 9" />
                <img className="pt2" src={logo10} alt="Client 10" />
                <img src={logo11} alt="Client 11" />
                <img src={logo12} alt="Client 12" />
                <img src={logo13} alt="Client 13" />
                <img src={logo14} alt="Client 14" />
                <img className="pt3" src={logo15} alt="Client 15" />
                <img src={logo16} alt="Client 16" />
                <img src={logo17} alt="Client 17" />
                <img src={logo18} alt="Client 18" />
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Client;